<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Task</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <v-menu bottom left>
        <v-btn slot="activator" icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in items" :key="i" click>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container fluid>
              <v-layout wrap>
                
                <v-flex xs8 sm8>
                  <v-text-field multiple label="Subject" prepend-icon="wc" v-model="editedItem.Subject"></v-text-field>
                </v-flex>
                
                <v-flex xs8 sm8>
                  <v-text-field multiple label="Class ID" prepend-icon="person_pin" v-model="editedItem.ClassID"></v-text-field>
                </v-flex>

                <v-flex xs8 sm8>
                  <v-text-field multiple label="Contract" prepend-icon="scanner" v-model="editedItem.Contract"></v-text-field>
                </v-flex>
                
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" outline @click.native="close">Cancel</v-btn>
            <v-btn color="blue darken-1" outline @click.native="save">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1">
      <template slot="items" slot-scope="props">
        
        <td>{{ props.item.Subject }}</td>
        <td>{{ props.item.ClassID }}</td>
        <td>{{ props.item.Contract }}</td>

        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)">
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    search: '',
    items: [
      { title: 'Clear Items' },
      { title: 'Edit details' },
      { title: 'Delete' }
    ],

    headers: [
      {
        text: 'Subject',
        align: 'left',
        sortable: true,
        value: 'Subject'
      },
      {
        text: 'Class ID',
        align: 'left',
        sortable: true,
        value: 'ClassID'
      },
      {
        text: 'Contract',
        align: 'left',
        sortable: true,
        value: 'Contract'
      },
      // { text: 'HolidayDate.', value: 'HolidayDate' },
      // { text: 'Description', value: 'Description' },
      // { text: 'Status', value: 'Status' },
      // { text: 'TriggerDate', value: 'TriggerDate' },
      // { text: 'TaskContent', value: 'TaskContent' },
      // { text: 'TaskDueDate', value: 'TaskDueDate' },
      { text: 'Action', value: 'action', align: 'middle' },
    ],

    desserts: [],
    editedIndex: -1,
    editedItem: {

      Subject: '',
      ClassID: '',
      Contract: ''
    },
    defaultItem: {

      Subject: '',
      ClassID: '',
      Contract: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.desserts = [
        {
          Subject: 'Subject 1',
          ClassID: 'Class ID 1',
          Contract: 'Contract 1'
        },
        {
          Subject: 'Subject 2',
          ClassID: 'Class ID 2',
          Contract: 'Contract 2'
        },
        {
          Subject: 'Subject 3',
          ClassID: 'Class ID 3',
          Contract: 'Contract 3'
        },
      ];
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.desserts.indexOf(item);
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1);
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/contact/ContactCases.vue